import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBookingDetailsData,
  updateCustomerDetails,
  updatePaymentDetails,
  updateInvoiceDetails,
  updateBookingDetailsEditable,
  updateIsBookingAltertionAllowed,
} from "../../reducer/bookingReducer";
import { bookingDetailsById } from "../../services/booking";
import moment from "moment";

const useStoreBookingDetailsLogic = () => {
  const dispatch = useDispatch();

  const { hotelDetails } = useSelector((store) => store.login);
  const { showMainBookingDetailsDrawer, mobileBookingDetailsId } = useSelector(
    (store) => store.booking
  );
  const { showNightAuditRoomDarwer } = useSelector((store) => store.nightAudit);
  const { isAllHotelsSelected } = useSelector((store) => store.login);

  const { editBookingAllowed, manageCompletedBookingAllowed } = useSelector(
    (store) => store.usersRestriction
  );
  const { currentNightAuditDate } = useSelector((store) => store.appHeader);

  const bookingId = Boolean(showMainBookingDetailsDrawer?.bookingId)
    ? showMainBookingDetailsDrawer?.bookingId
    : mobileBookingDetailsId;

  // Api Hitting for Booking details for both screen
  useEffect(() => {
    if (
      Boolean(hotelDetails?.id) ||
      Boolean(bookingId) ||
      showNightAuditRoomDarwer
    )
      performApi();
  }, [bookingId, mobileBookingDetailsId, showNightAuditRoomDarwer]);

    useEffect(() => {
    if (Boolean(hotelDetails?.id) && Boolean(bookingId)) performApi();
  }, [bookingId, mobileBookingDetailsId]);
 
  const performApi = async () => {
    const bookingDetailsPayload = {
      id: bookingId,
      hotelId: hotelDetails.id,
    };

    dispatch(updateInvoiceDetails([]));
    dispatch(updateBookingDetailsEditable({}));
    dispatch(updateCustomerDetails({}));
    dispatch(updatePaymentDetails());

    dispatch(
      updateBookingDetailsData({
        loadingDetails: true,
        responseDetails: {},
        responseDetailsApiError: false,
      })
    );

    const response = await bookingDetailsById(
      bookingDetailsPayload,
      "bookings"
    );

    if (Boolean(response.data)) {
      // api success phase
      dispatch(
        updateBookingDetailsData({
          loadingDetails: false,
          responseDetails: response.data,
          responseDetailsApiError: false,
        })
      );
      let bookingDetails = Boolean(response.data)
        ? response?.data?.bookingDetails
        : {};
      dispatch(updateBookingDetailsEditable(bookingDetails));

      let customerDetails = Boolean(response.data)
        ? response?.data?.customerDetails
        : {};
      dispatch(updateCustomerDetails(customerDetails));

      let invoiceDetails = Boolean(response.data)
        ? response?.data?.invoiceDetails
        : [];
      dispatch(updateInvoiceDetails(invoiceDetails));

      let paymentDetails = Boolean(response.data)
        ? response?.data?.paymentDetails
        : [];
      dispatch(updatePaymentDetails(paymentDetails));

      let checkOutDate = moment(bookingDetails?.checkOut)?.format("YYYY-MM-DD");

      const daysDifference = moment(currentNightAuditDate)?.diff(
        checkOutDate,
        "days"
      );

      let editCompleteBookingAllowed =
        manageCompletedBookingAllowed || daysDifference <= 0;

      let bookingType = bookingDetails?.status;

      let isBookingAlterationAllowed = isAllHotelsSelected
        ? false
        : bookingType === "completed" ||
          bookingType === "noShow" ||
          bookingType === "cancelled"
        ? editCompleteBookingAllowed
        : editBookingAllowed;

      dispatch(
        updateIsBookingAltertionAllowed(Boolean(isBookingAlterationAllowed))
      );
    } else {
      dispatch(
        updateBookingDetailsData({
          loadingDetails: false,
          responseDetails: {},
          responseDetailsApiError: true,
        })
      );
    }
  };
};

export default useStoreBookingDetailsLogic;
